import React, { useState } from "react";
import { Card, CardBody, Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";

const ImagePreviewModal = ({
    imagePreviewModalOpenClose,
    setImagePreviewModalOpenClose,
}) => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!imagePreviewModalOpenClose) return null;

    const toggleImagePreviewModal = () => {
        setImagePreviewModalOpenClose(!imagePreviewModalOpenClose)
    }

    return (
        <>
            <Modal
                isOpen={imagePreviewModalOpenClose}
                toggle={toggleImagePreviewModal}
                backdrop="static"
                centered
                size="md"
                className="image-preview-modal"
            >
                <ModalHeader toggle={toggleImagePreviewModal}>
                    Preview Image
                </ModalHeader>

                <ModalBody className="p-0">
                    <img
                        src="https://is1-ssl.mzstatic.com/image/thumb/Purple111/v4/dd/95/7e/dd957e3a-abd3-da8a-2211-726a67108938/source/256x256bb.jpg"
                        alt="Preview"
                        className="img-fluid w-100 h-100 image-padding-pos"
                    />
                </ModalBody>
            </Modal>

        </>
    );
};

export default ImagePreviewModal;
